import {
  Avatar,
  lighten,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Skeleton,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';
import WorkspaceAPI from '../../../../redux/workspace/WorkspaceAPI';
import useWatchError from '../../../../shared/hooks/useWatchError';
import WorkspaceActions from './WorkspaceActions/WorkspaceActions';

interface WorkspaceItemProps {
  workspaceId: string;
  onClick?: () => void;
  workspaceIdSelected?: string | null;
}

function WorkspaceItem(props: WorkspaceItemProps) {
  const { workspaceId, onClick, workspaceIdSelected } = props;
  const {
    data: workspace,
    error,
    isLoading,
  } = WorkspaceAPI.useGetWorkspaceByIdQuery(workspaceId);
  useWatchError(error);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const image = workspace?.images?.logo;
  const isSelected = workspaceId === workspaceIdSelected;

  if (isLoading) {
    return <WorkspaceItemSkeleton />;
  }

  return (
    <ListItem
      disablePadding
      secondaryAction={
        <WorkspaceActions {...props} workspaceId={workspace?.id} />
      }
    >
      <StyledListItemButton onClick={onClick} selected={isSelected}>
        <ListItemAvatar>
          <Avatar src={image} alt={workspace?.name}>
            {!image && workspace?.name.charAt(0).toUpperCase()}
          </Avatar>
        </ListItemAvatar>
        {isMobile && workspaceIdSelected ? null : (
          <ListItemText primary={workspace?.name} />
        )}
      </StyledListItemButton>
    </ListItem>
  );
}

export const WorkspaceItemSkeleton = () => {
  return (
    <ListItem disablePadding>
      <StyledListItemButton>
        <ListItemAvatar>
          <Skeleton variant="circular" width={40} height={40} />
        </ListItemAvatar>
        <ListItemText>
          <Skeleton variant="text" width="60%" />
        </ListItemText>
      </StyledListItemButton>
    </ListItem>
  );
};

export const StyledListItemButton = styled(ListItemButton)<{
  selected?: boolean;
}>(({ theme, selected }) => ({
  backgroundColor: selected
    ? lighten(theme.palette.primary.main, 0.85)
    : lighten(theme.palette.background.paper, 0.1),
  borderLeft: selected
    ? `4px solid ${theme.palette.primary.main}`
    : `4px solid ${theme.palette.text.primary}`,
  color: theme.palette.text.primary,
  my: 0.5,
  display: 'flex',
  justifyContent: 'space-between',
  '&:hover': {
    backgroundColor: selected
      ? lighten(theme.palette.primary.main, 0.75)
      : lighten(theme.palette.background.paper, 0.2),
  },
}));

export default WorkspaceItem;
